import {
  Box,
  boxClasses,
  stackClasses,
  styled,
  tableBodyClasses,
  tableRowClasses,
} from "@mui/material"
import { Table, type TableProps } from "../table"
import type { RankedBarTableItem } from "./rankedBarTable.model"

type RankedBarTableProps<QR, R, E> = TableProps<QR, R, E>

export const RankedBarTable = <
  QR,
  R extends RankedBarTableItem = RankedBarTableItem,
  E = {},
>(
  props: RankedBarTableProps<QR, R, E>,
) => {
  return (
    <RankedBarTableContainer>
      <Table<QR, R, E> {...props} />
    </RankedBarTableContainer>
  )
}

export const RankedBarTableContainer = styled(Box)({
  [`& .${tableBodyClasses.root} .${tableRowClasses.root}`]: {
    backgroundColor: "transparent !important",
  },
  // disable padding left-right for all stack around table Element
  [`& .table-container>.${stackClasses.root}, & .table-container>.${boxClasses.root}`]:
    {
      paddingInline: 0,
    },
  // disable first non-table element top padding
  [`& .table-container>.${stackClasses.root}:first-of-type`]: {
    paddingTop: 0,
  },
})
